import { APIResponseType, CategoriesValue, createGetApiHook } from "@/shared";

export const useGetCategories = createGetApiHook<
  APIResponseType<CategoriesValue[]>,
  {}
>(`/categories`);